export default {"src":"/_next/static/media/gh-icon-white.1087f238.svg","height":35,"width":16};